import { render, staticRenderFns } from "./FundsMgmtSettingDrawer.vue?vue&type=template&id=5dba5a31"
import script from "./FundsMgmtSettingDrawer.vue?vue&type=script&lang=js"
export * from "./FundsMgmtSettingDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports